import type { ReactNode } from 'react'

export type EventField = { label: string; value: ReactNode }

export function EventFieldGrid({ fields }: { fields: EventField[] }) {
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
      {fields.map((f, i) => {
        const empty = f.value == null || f.value === ''
        return (
          <div key={i} className="min-w-0">
            {f.label ? <span className="whitespace-nowrap text-muted-foreground">{f.label}: </span> : null}
            <span className="font-semibold">{empty ? '—' : f.value}</span>
          </div>
        )
      })}
    </div>
  )
}
